<template>
    <table>
        <tr>
            <td class="font-bold text-right align-bottom">
                {{ $t('cart.total') }}
            </td>
            <td class="text-right align-top px-4">
                {{ totalPrice | price(true) }}
            </td>
        </tr>
        <tr>
            <td class="font-bold text-right align-bottom">
                {{ $t('cart.deduction') }}
            </td>
            <td class="text-right align-top px-4">
                <div v-if="dsctAmt">
                    {{ dsctAmt | price }}
                </div>
            </td>
        </tr>
        <tr>
            <td class="font-bold text-right align-bottom">
                {{ $t('cart.totalPrice') }}
            </td>
            <td class="text-right align-top px-4">
                {{ Math.max(totalPrice - dsctAmt, 0) | price(true) }}
            </td>
        </tr>
        <tr
            v-if="
                showCrdtPntEarnAmt &&
                    (crdtPntEarnAmt > 0 || luckydraw2021EarnAmt > 0)
            "
        >
            <td class="text-right align-bottom">
                此次可獲得：
            </td>
        </tr>
        <tr v-if="showCrdtPntEarnAmt && crdtPntEarnAmt > 0">
            <td class="flex justify-end align-bottom">
                <msgSlot msgKey="{0}{1}" class="flex items-center">
                    <template #slot0>
                        <div class="text-right align-bottom">T-coins</div>
                    </template>
                    <template #slot1>
                        <div class="icon text-primary mr-1">
                            <tryhalaCoinSvg />
                        </div>
                    </template>
                </msgSlot>
            </td>
            <td class="text-right align-top px-4 font-bold">
                {{ crdtPntEarnAmt }}
            </td>
        </tr>
        <tr v-if="showCrdtPntEarnAmt && luckydraw2021EarnAmt > 0">
            <td class="flex justify-end align-bottom">
                <msgSlot msgKey="{0}{1}" class="flex items-center">
                    <template #slot0>
                        <div class="text-right align-bottom">幸運大抽獎</div>
                    </template>
                    <template #slot1>
                        <img class="w-6 h-6" :src="imgPrmtEvntGiftIcon" />
                    </template>
                </msgSlot>
            </td>
            <td class="text-right align-top px-4 font-bold">
                {{ luckydraw2021EarnAmt }}
            </td>
        </tr>
        <tr v-for="(i, ii) in additionalInfoList" :key="ii">
            <td class="text-right">{{ i.label }}:</td>
            <td class="pl-2">
                <slot :name="i.slotName">{{ i.desp }}</slot>
            </td>
        </tr>
    </table>
</template>

<script>
import price from '@/components/priceFilter';
import tryhalaCoinSvg from '@/assets/svg/tryhala_coin.svg';
import msgSlot from '@/components/msgSlot';
import imgPrmtEvntGiftIcon from '@/assets/img/promotion_event_gift_icon.png';

export default {
    components: {
        tryhalaCoinSvg,
        msgSlot
    },
    props: {
        list: { type: Array, default: () => [] },
        dsctAmt: { type: Number, default: 0 },
        additionalInfoList: { type: Array, default: () => [] },
        showCrdtPntEarnAmt: { type: Boolean, default: true },
        crdtPntEarnAmt: { type: Number, default: 0 }
    },
    filters: { price },
    created() {
        this.imgPrmtEvntGiftIcon = imgPrmtEvntGiftIcon;
    },
    computed: {
        totalPrice() {
            return this.$store.getters.totalPrice(this.list);
        },
        luckydraw2021EarnAmt() {
            return this.$store.getters.luckydraw2021EarnAmt(this.list);
        }
    }
};
</script>
